import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { ISO_8601 } from 'moment';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AppRoutingModule } from './app-routing.module';
import { HttpCustomInterceptor } from './service/httpcustominterceptor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import 'hammerjs';
import { faHome, faUser, faAddressCard, faUnlockAlt, faSignOutAlt, faArchive,
    faListAlt, faCheckSquare, faArrowLeft, faFileDownload, faDownload, faSearch,
    faSearchMinus, faSearchPlus, faUndoAlt, faRedoAlt, faAngleLeft, faAngleRight,
    faGraduationCap, faSignInAlt, faPowerOff, faAward, faEdit, faBars,
    faExclamationTriangle, faBookOpen, faFileExport, faGreaterThan, faExpand,
    faCompress, faPlay, faPause} from '@fortawesome/free-solid-svg-icons';

// components
import { AppComponent } from './app.component';
import { HomeComponent } from './component/home/home.component';
import { LoginComponent } from './component/login/login/login.component';
import { PlatformComponent } from './component/platform/platform/platform.component';
import { HeaderComponent } from './component/header/header.component';
import { ChangePasswordComponent } from './component/change-password/change-password/change-password.component';
import { LeftMenuComponent } from './component/menu/left-menu/left-menu/left-menu.component';
import { ProfiloComponent } from './component/profilo/profilo/profilo.component';

// services
import { UserService } from './service/user.service';
import { DomainService } from './service/domain.service';
import { RestorePasswordComponent } from './component/restore-password/restore-password/restore-password.component';
import { CourseComponent } from './component/course/course/course.component';
import { EmailPhaseComponent } from './component/restore-password/email-phase/email-phase.component';
import { CodePhaseComponent } from './component/restore-password/code-phase/code-phase.component';
import { NewPasswordPhaseComponent } from './component/restore-password/new-password-phase/new-password-phase.component';
import { SlideViewerComponent } from './component/course/slide-viewer/slide-viewer.component';
import { EsercitazioneComponent } from './component/esercitazione/esercitazione/esercitazione.component';
import { EsercitazioneSvolgimentoComponent } from './component/esercitazione/esercitazione-svolgimento/esercitazione-svolgimento.component';
import { EsercitazioneValutazioneComponent } from './component/esercitazione/esercitazione-valutazione/esercitazione-valutazione.component';
import { EsercitazioniArchivioComponent } from './component/esercitazione/esercitazioni-archivio/esercitazioni-archivio.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { ModuloComponent } from './component/course/modulo/modulo/modulo.component';
import { PlayerAudioComponent } from './component/player/player-audio/player-audio.component';
import { TimeFormatPipe } from './pipe/time-format.pipe';
import { AlertDialogComponent } from './dialog/alert-dialog/alert-dialog.component';
import { EsercitazioniModuloComponent } from './component/esercitazione/esercitazioni-modulo/esercitazioni-modulo.component';
import { EsercitazioniCorsoComponent } from './component/esercitazione/esercitazioni-corso/esercitazioni-corso.component';
import { PlayerVideoComponent } from './component/player/player-video/player-video.component';
import { CorsoModuloMainComponent } from './component/course/corso-modulo-main/corso-modulo-main.component';
import { FirstChangePasswordComponent } from './component/change-password/first-change-password/first-change-password.component';
import { DefaultChangePasswordComponent } from './component/change-password/default-change-password/default-change-password.component';
import { LezioneComponent } from './component/course/lezione/lezione.component';
import { PlayerVimeoComponent } from './component/player/player-vimeo/player-vimeo.component';


export const DATE_FORMAT = {
    parse: {
        dateInput: ISO_8601
    },
    display: {
        dateInput: 'L',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'L',
        monthYearA11yLabel: 'MMM YYYY'
    }
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    PlatformComponent,
    HeaderComponent,
    ChangePasswordComponent,
    LeftMenuComponent,
    ProfiloComponent,
    RestorePasswordComponent,
    CourseComponent,
    EmailPhaseComponent,
    CodePhaseComponent,
    NewPasswordPhaseComponent,
    SlideViewerComponent,
    EsercitazioneComponent,
    EsercitazioneSvolgimentoComponent,
    EsercitazioneValutazioneComponent,
    EsercitazioniArchivioComponent,
    DashboardComponent,
    ModuloComponent,
    PlayerAudioComponent,
    TimeFormatPipe,
    AlertDialogComponent,
    EsercitazioniModuloComponent,
    EsercitazioniCorsoComponent,
    PlayerVideoComponent,
    CorsoModuloMainComponent,
    FirstChangePasswordComponent,
    DefaultChangePasswordComponent,
    LezioneComponent,
    PlayerVimeoComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatDialogModule,
    NgbTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    FontAwesomeModule,
    PdfViewerModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCustomInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
    HttpClient,
    UserService,
    DomainService
  ],
  entryComponents: [AlertDialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule {
    constructor() {
        library.add(faHome, faUser, faAddressCard, faUnlockAlt, faBars, faBookOpen,
                    faEdit, faAward, faPowerOff, faSignInAlt, faSignOutAlt,
                    faGraduationCap, faArchive, faListAlt, faCheckSquare, faArrowLeft,
                    faFileDownload, faDownload, faSearch, faSearchMinus, faSearchPlus,
                    faUndoAlt, faRedoAlt, faAngleLeft, faAngleRight, faExclamationTriangle,
                    faFileExport, faGreaterThan, faExpand, faCompress, faPlay, faPause);
    }
}
